import { isRouteErrorResponse, useRouteError } from 'react-router';
import { useGo } from './navigation';

/** Shown inside the shell when a page fails to render. */
export function PageError() {
  const go = useGo();
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error);
  return (
    <div className="panel">
      <h2>Bu sayfa açılamadı</h2>
      <p>{message}</p>
      <button type="button" className="btn btn-primary" onClick={() => go('ana')}>
        Ana sayfaya dön
      </button>
    </div>
  );
}
